import { render, staticRenderFns } from "./ShowImage.vue?vue&type=template&id=21077a84&scoped=true&"
import script from "./ShowImage.vue?vue&type=script&lang=ts&"
export * from "./ShowImage.vue?vue&type=script&lang=ts&"
import style0 from "./ShowImage.vue?vue&type=style&index=0&id=21077a84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21077a84",
  null
  
)

export default component.exports